export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export function addDaysIso(iso, days) {
  const d = new Date(iso);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

export function formatEventTime(ev) {
  if (!ev || !ev.start_at) return "—";
  const start = new Date(ev.start_at);
  const end = ev.end_at ? new Date(ev.end_at) : null;
  const sameDay = end && start.toDateString() === end.toDateString();
  const dateStr = start.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
  const startStr = start.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  if (!end) return `${dateStr} · ${startStr}`;
  const endStr = end.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  return sameDay ? `${dateStr} · ${startStr} – ${endStr}` : `${dateStr} ${startStr} → ${end.toLocaleString()}`;
}
